import { MantineThemeOverride } from '@mantine/core';

export type AvatarTheme = NonNullable<MantineThemeOverride['components']>['Avatar'];

export const Avatar: AvatarTheme = {
  // todo: define
};
